import type { Config } from '@avalara/types/index';

const envConfig: Record<string, Config> = {
  local: {
    AI_URL: 'https://identity.qa.avalara.io',
    AI_CLIENT_ID: 'aui-identity',
    INTEGRATIONS_URL: 'https://avaapp.gamma.qa.us-west-2.aws.avalara.io/integrations',
    AA_URL: 'https://account.gamma.qa.us-west-2.aws.avalara.io',
    API_URL: 'https://buy.gamma.qa.us-west-2.aws.avalara.io',
    ASSET_PATH: '',
    AVAAPP_URL: 'https://avaapp.gamma.qa.us-west-2.aws.avalara.io',
    AVATAX_URL: 'https://api.qa.avalara.io/api/v2',
    AVATAX_ONBOARDING_COMPANY_CODE: 'DEFAULT',
    BIZ_LICENSE_API: 'https://www.businesslicenses.com',
    BIZTECH_URL: 'https://api.fqa.biztech.avalara.net',
    USAGE_SERVICE_URL: 'https://usage.gamma.dev.us-west-2.aws.avalara.io',
    CAMUNDA_API: 'https://camunda.registrations-qa.avalara.net',
    CONNECTOR_URL: 'https://qa.api.connectors.avalara.com/connectors',
    CLIENT_URL: 'https://avaapp.gamma.qa.us-west-2.aws.avalara.io',
    BUY_CLIENT_URL: 'https://avaapp.gamma.qa.us-west-2.aws.avalara.io/buy',
    CUP_URL: 'https://qa.admin.web.avalara.io',
    HOME_URL: 'https://avaapp.gamma.qa.us-west-2.aws.avalara.io/home',
    IAM_URL: 'https://api.qa.avalara.io/iam',
    IPS_URL: 'https://api.ips.qa.avalara.io',
    KOALA_URL: 'https://k6kex693gk-vpce-0f56d363d11549d62.execute-api.us-west-2.amazonaws.com/qa',
    NEXT_BEST_PRODUCT_URL: 'https://next-best-product-dev.avlr.net/dev',
    NEXUS_URL: 'https://sandbox-rest.avatax.com',
    ONBOARDING_URL: 'https://qa.onboarding.web.avalara.io',
    SUPPORT_URL: 'https://avalara--fullqa.sandbox.my.site.com/SupportCases/services/auth/sso/AvalaraIdentity',
    MANDRILL_ENDPOINT: 'https://mandrillapp.com/api/1.0/messages/send-template.json',
    ELR_ENTRYPOINT_URL: '',
    DBNA_ENTRYPOINT_URL: '',
    MTG_API_URL: 'https://miles.develop.avlr.net/api/v1.3',
    MTG_ELOQUA_FORM: 'MILES-BuyTech-Testing',
    MOCK_RESPONSES: false,
    auiWorkflowUrl: 'https://auiworkflow.gamma.qa.us-west-2.aws.avalara.io',
    cybersourcePageHost: 'https://testsecureacceptance.cybersource.com',
    cybersourceMerchants: {
      USD: {
        profileId: 'ECC0C6B0-2443-4622-9968-1612E03ED9B9',
        publicKey: '42678acd325937f6b87cf74278559f8d',
        privateKeySecretName: 'CYBERSOURCE_CC_SECRET_KEY',
      },
    },
    redis: {
      sessionLimit: 18000,
    },
    snowflake: {
      account: 'AVALARA_DEV',
      database: 'DEV_FQA',
      schema: 'REPORTING_DBT',
      warehouse: 'CUP_FQA_WH',
      role: 'QA_CUP_REPORTS_ROLE',
    },
  },
  qa: {
    AA_URL: 'https://account.gamma.qa.us-west-2.aws.avalara.io',
    AI_URL: 'https://identity.qa.avalara.io',
    AI_CLIENT_ID: 'aui-identity',
    API_URL: 'https://buy.gamma.qa.us-west-2.aws.avalara.io',
    ASSET_PATH: 'https://assets.avalara.io/buy',
    AVAAPP_URL: 'https://avaapp.gamma.qa.us-west-2.aws.avalara.io',
    AVATAX_ONBOARDING_COMPANY_CODE: 'DEFAULT',
    AVATAX_URL: 'https://api.qa.avalara.io/api/v2',
    BIZTECH_URL: 'https://api.fqa.biztech.avalara.net',
    BIZ_LICENSE_API: 'https://www.businesslicenses.com',
    CAMUNDA_API: 'https://camunda.registrations-qa.avalara.net',
    CLIENT_URL: 'https://avaapp.gamma.qa.us-west-2.aws.avalara.io',
    BUY_CLIENT_URL: 'https://avaapp.gamma.qa.us-west-2.aws.avalara.io/buy',
    CONNECTOR_URL: 'https://qa.api.connectors.avalara.com/connectors',
    CUP_URL: 'https://qa.admin.web.avalara.io',
    HOME_URL: 'https://avaapp.gamma.qa.us-west-2.aws.avalara.io/home',
    IAM_URL: 'https://api.qa.avalara.io/iam',
    INTEGRATIONS_URL: 'https://avaapp.gamma.qa.us-west-2.aws.avalara.io/integrations',
    IPS_URL: 'https://api.ips.qa.avalara.io',
    KOALA_URL: 'https://k6kex693gk-vpce-0f56d363d11549d62.execute-api.us-west-2.amazonaws.com/qa',
    MANDRILL_ENDPOINT: 'https://mandrillapp.com/api/1.0/messages/send-template.json',
    ELR_ENTRYPOINT_URL: '',
    DBNA_ENTRYPOINT_URL: '',
    MOCK_RESPONSES: false,
    MTG_API_URL: 'https://miles.develop.avlr.net/api/v1.3',
    MTG_ELOQUA_FORM: 'MILES-BuyTech-Testing',
    NEXT_BEST_PRODUCT_URL: 'https://next-best-product-stage.avlr.net/stage',
    NEXUS_URL: 'https://sandbox-rest.avatax.com',
    ONBOARDING_URL: 'https://qa.onboarding.web.avalara.io',
    SUPPORT_URL: 'https://avalara--fullqa.sandbox.my.site.com/SupportCases/services/auth/sso/AvalaraIdentity',
    USAGE_SERVICE_URL: 'https://usage.gamma.dev.us-west-2.aws.avalara.io',
    auiWorkflowUrl: 'https://auiworkflow.gamma.qa.us-west-2.aws.avalara.io',
    cybersourcePageHost: 'https://testsecureacceptance.cybersource.com',
    cybersourceMerchants: {
      USD: {
        profileId: '22CD2028-3BB1-48C9-A3E9-395E138C7F9B',
        publicKey: 'f9c0177e03693c86a37da3b4d14d3184',
        privateKeySecretName: 'CYBERSOURCE_CC_SECRET_KEY',
      },
    },
    redis: {
      sessionLimit: 18000,
    },
    snowflake: {
      account: 'AVALARA_DEV',
      database: 'DEV_FQA',
      schema: 'REPORTING_DBT',
      warehouse: 'CUP_FQA_WH',
      role: 'QA_CUP_REPORTS_ROLE',
    },
  },
  prod: {
    AI_URL: 'https://identity.avalara.com',
    AI_CLIENT_ID: 'aui-identity-prd',
    INTEGRATIONS_URL: 'https://app.avalara.com/integrations',
    AA_URL: 'https://account.avalara.com',
    AA_SBX_URL: 'https://sandbox.account.avalara.com',
    API_URL: 'https://buy.gamma.prd.us-west-2.aws.avalara.io',
    ASSET_PATH: 'https://assets.avalara.com/buy',
    AVAAPP_URL: 'https://app.avalara.com',
    AVATAX_URL: 'https://rest.avatax.com/api/v2',
    AVATAX_ONBOARDING_COMPANY_CODE: 'AVALARA',
    BIZ_LICENSE_API: 'https://www.businesslicenses.com',
    BIZTECH_URL: 'https://api.biztech.avalara.com',
    USAGE_SERVICE_URL: 'https://usage.gamma.prd.us-west-2.aws.avalara.io',
    CAMUNDA_API: 'https://camunda.registrations-eu.avalara.net',
    CONNECTOR_URL: 'https://api.connectors.avalara.com/connectors',
    CLIENT_URL: 'https://app.avalara.com',
    BUY_CLIENT_URL: 'https://app.avalara.com/buy',
    CUP_URL: 'https://admin.avalara.com',
    CUP_SBX_URL: 'https://sandbox.admin.avalara.com',
    HOME_URL: 'https://app.avalara.com/home',
    IAM_URL: 'https://rest.avatax.com/iam',
    IPS_URL: 'https://api.ips.avalara.com',
    KOALA_URL: 'https://4ft1soox85-vpce-086efd92a1305cf6b.execute-api.us-west-2.amazonaws.com/prod',
    NEXT_BEST_PRODUCT_URL: 'https://next-best-product-prod.avlr.net/prod',
    NEXUS_URL: 'https://rest.avatax.com',
    ONBOARDING_URL: 'https://onboarding.avalara.com',
    SUPPORT_URL: 'https://community.avalara.com/support/services/auth/sso/AvalaraIdentity',
    MANDRILL_ENDPOINT: 'https://mandrillapp.com/api/1.0/messages/send-template.json',
    ELR_ENTRYPOINT_URL: '',
    DBNA_ENTRYPOINT_URL: '',
    MTG_API_URL: 'https://miles.marketing.avalara.com/api/v1.3',
    MTG_ELOQUA_FORM: 'MILES-BuyTech',
    MOCK_RESPONSES: false,
    auiWorkflowUrl: 'https://auiworkflow.avalara.com',
    cybersourcePageHost: 'https://secureacceptance.cybersource.com',
    cybersourceMerchants: {
      USD: {
        profileId: '8BFB5DD7-F59E-44E4-81C4-93DC3856624C',
        publicKey: '98bfa0f963843d4f97c672b9d02be5c8',
        privateKeySecretName: 'CYBERSOURCE_CC_SECRET_KEY',
      },
    },
    redis: {
      sessionLimit: 18000,
    },
    snowflake: {
      account: 'AVALARA_PROD',
      database: 'PROD',
      schema: 'REPORTING_DBT',
      warehouse: 'CUP_PRD_WH_XS',
      role: 'prd_cup_reports_role',
    },
  },
};

export default envConfig;
